export const createHead = () => {
    const head = {
        cells: [
            {
                key: "blocker.blockerName",
                content: "Blockername",
            },
            {
                key: "blocker.start_time",
                content: "Startzeit",
            },
            {
                key: "blocker.end_time",
                content: "Endzeit",
            },
            {
                key: "blocker.delete",
                content: "Abbrechen",
            },
        ],
    };

    return head;
};
